import * as React from 'react';
import * as ToastPrimitives from '@radix-ui/react-toast';
import useToast from '../hooks/use-toast';
import Toast from './Toast';
import { setToastInstance } from '../utils/toast';

interface ToastProviderProps {
  children: React.ReactNode;
}

const ToastProvider: React.FC<ToastProviderProps> = ({ children }) => {
  const toastHook = useToast();
  const { toasts, dismiss } = toastHook;

  // Set the global toast instance
  React.useEffect(() => {
    setToastInstance(toastHook);
  }, [toastHook]);

  return (
    <ToastPrimitives.Provider>
      {children}
      <ToastPrimitives.Viewport
        style={{
          position: 'fixed',
          bottom: '0px',
          right: '8px',
          zIndex: 50,
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
        }}
      />
      {toasts.map((toast) => (
        <Toast
          key={toast.id}
          id={toast.id}
          title={toast.title}
          description={toast.description}
          variant={toast.variant}
          onDismiss={dismiss}
        />
      ))}
    </ToastPrimitives.Provider>
  );
};

export default ToastProvider;
